import { DEFAULT_SKIN } from '../constants/marketplace';
import { useSkin } from '../contexts/SkinContext';

export const useSkinConfigs = <T>(skinnedConfig: Record<string, T>) => {
  const { skin } = useSkin();
  return skinnedConfig[skin] || skinnedConfig[DEFAULT_SKIN];
};
